module.exports = __webpack_public_path__ + "static/media/womenGroupHuggingTogether.79c87ba6.png";